import VistaQR from "@/views/VistaQR.vue";

const qr = {
  path: "/qr",
  name: "qr",
  component: VistaQR,
};

export default qr;
